import type { PropsWithChildren } from 'react';
import type React from 'react';
import styled from 'styled-components';

export const MainArea: React.FC<PropsWithChildren> = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  flex: 1;
  transition: margin-right 0.3s ease;
  background: ${({ theme }): string => theme.customPalette.panels.mainarea};
`;
